module.exports = __webpack_public_path__ + "img/sliderverify.095a4cbf.png";